<template>
  <div id="app" :class="app_class" class="h-full">
    <Header/>
    <Sidebar v-if="client.authenticated" :class="{ visible: showsidebar }" id="sidebar" />
    <div id="content-wrapper" class="h-full" :class="{ withsidebar: showsidebar }">
      <div id="content" class="h-full">
        <transition name="fade" mode="out-in"><router-view /></transition>
      </div>
    </div>
    <Modal id='confirm-modal' size="small" @ok="confirm_ok" :title="$store.state.confirm_opts.title">
      {{ $store.state.confirm_opts.message }}
    </Modal>
  </div>
</template>

<script src="https://cdn.jsdelivr.net/npm/web-streams-polyfill@2.0.2/dist/ponyfill.min.js"></script>
<script>
import Header from './components/header.vue'
import Sidebar from './components/sidebar.vue'
import Modal from './components/modal.vue'

export default {
  name: 'App',
  components: {
    Modal,
    Header,
    Sidebar,
  },
  computed: {
    showsidebar() {
      return this.screen_lg && this.$route.meta.sidebar;
    },
    app_class() {
      var ret = [];
      if (this.screen_lg) {
        ret.push("lg");
      }
      if (this.screen_md) {
        ret.push("md");
      } else {
        ret.push("sm");
      }
      if (this.$route.meta.bg_class) {
        ret.push(this.$route.meta.bg_class);
      }
      return ret;
    }
  },
  asyncComputed: {
  },
  methods: {
    confirm_ok() {
      var ok = this.$store.state.confirm_opts.ok;
      if (ok) {
        ok();
      }
    },
    include_tidio() {
      if (process.env.VUE_APP_PEPPER_ENV == "test") {
        return;
      }
      let recaptchaScript = document.createElement('script')
      recaptchaScript.setAttribute('src', 'https://code.tidio.co/rgdxtzdj2uk6lznytuofozk14mxeghah.js')
      document.head.appendChild(recaptchaScript)
    },
  },
  mounted: function () {
    window.addEventListener("resize", () => {
      this.screen_width = window.innerWidth;
      process.nextTick(this.$forceUpdate.bind(this));
    });
    this.include_tidio();
  }
}
</script>

<style>
@import "../fomantic/src/dist/semantic.css";
@import "https://unpkg.com/tailwindcss@1.4.6/dist/tailwind.min.css";

#app.bg-login {
  background-image: url(./assets/login-bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
}

#app.bg-register {
  background-image: url(./assets/register-bg.jpg);
  background-repeat: no-repeat;
  background-size: cover;
}

#app {
  font-family: -apple-system,BlinkMacSystemFont,Helvetica Neue,PingFang SC,Microsoft YaHei,Source Han Sans SC,Noto Sans CJK SC,WenQuanYi Micro Hei,sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

body {
  padding-top: 50px;
}

#content {
  text-align: left;
}

.md #content {
  padding: 2rem !important;
}

.sm #content {
  padding: 1.5rem 1rem 0 1rem !important;
}

#content-wrapper.withsidebar {
  margin-left: 200px !important;
}

#content-wrapper {
  backdrop-filter: blur(8px);
  top: 0 !important;
  left: 0 !important;
  right: 0 !important;
  position: absolute !important;
  padding-top: 50px !important;
  overflow-y: auto;
}

.ui.progress .bar {
  min-width: 0px;
}

a {
  cursor: pointer;
}

.sm .ui.table {
  margin-top: 0 !important;
}

.sm .grid .column {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.sm div.column {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
</style>
